import React, { useState, useEffect } from "react";
import carrito from "../img/carro-de-la-compra.png";
import "../css/cart.css";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import ContenidoCart from "./ContenidoCart";
import ContenidoCarritoCliente from "./ContenidoCarritoCliente";
import jwtDecode from "jwt-decode";
import { getToken } from "../../../api/token";

export default function Carrito(props) {
  
  const [iduser, setIduser] = useState(null)
  
  useEffect(() => {
    const token = getToken();
    if(token){
      setIduser(jwtDecode(token).data.user.id);
    }
 
  }, [])

  const {getProductsCart, productsCart} = props;
  

  const [openCart, setOpenCart] = React.useState(false);

  const ClickOpenCart = () => {
    setOpenCart(true);
  };
  const CloseCart = () => {
    setOpenCart(false);
  };

  if(iduser != null){
    return (
      <div>
  
          <button type="button" className="btn btn-lg" onClick={ClickOpenCart} id="carro" style={{"color": "white"}}>
            Ver Carrito 
            <img style={{"width": "35px", "height": "35px", "align": "right"}} src={carrito}alt="" />
            </button>
  
          <Dialog
          open={openCart}
          onClose={CloseCart}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"Mi Carrito"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             <ContenidoCart />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={CloseCart} color="secondary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
     
      </div>
    );
  }else{
    return (
      <div>
  
          <button type="button" className="btn btn-lg" onClick={ClickOpenCart} id="carro" style={{"color": "white"}}>
            Ver Carrito 
            <img style={{"width": "35px", "height": "35px", "align": "right"}} src={carrito}alt="" />
            </button>
  
          <Dialog
          open={openCart}
          onClose={CloseCart}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">{"Mi Carrito"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             <ContenidoCarritoCliente getProductsCart={getProductsCart} productsCart={productsCart} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={CloseCart} color="secondary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
     
      </div>
    );
    
  }
  
}
